import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createMarkupProfileEpic } from './_epics/createMarkupProfile.epic';
import { loadMarkupProfileEpic } from './_epics/loadMarkupProfile.epic';
import { loadMarkupProfileListEpic } from './_epics/loadMarkupProfileList.epic';
import { updateMarkupProfileEpic } from './_epics/updateMarkupProfile.epic';
import { removeMarkupProfileEpic } from './_epics/removeMarkupProfile.epic';

export const markupProfileEpic = safeCombineEpics(
  createMarkupProfileEpic,
  loadMarkupProfileEpic,
  loadMarkupProfileListEpic,
  updateMarkupProfileEpic,
  removeMarkupProfileEpic,
);
